import type { LinkFontSchemaType } from '@vedalib/editor/lib/brand'
import styled from 'styled-components'

import { font } from 'services/Branding/common.styled'
import type { ElementFontCss } from 'services/Branding/types'

const LinkStyled = styled.span<{ $font: ElementFontCss<LinkFontSchemaType>; $label?: string }>`
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  border-radius: 8px;
  ${({ $label, $font }) => $label && font($font.link)}
`

export default LinkStyled
